module.exports = __webpack_public_path__ + "static/img/Jack-Dalton.9a2439a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jack-Dalton.jpg
// module id = KuEU
// module chunks = 0